<template>
  <div class="files-list">
    <ul>
      <li
        v-for="fileWithMeta in files" :key="fileWithMeta.upload.uuid"
        class="files-list__item"
      >
        <span class="files-list__info">
          {{ fileWithMeta.name }} ({{ formatBytes(fileWithMeta.size) }}) - <span :class="statusClass(fileWithMeta)">
            {{ getStatusText(fileWithMeta) }}
            <template v-if="fileWithMeta.statusKey === 'uploading'">({{ fileWithMeta.upload.progress }}%)</template>
          </span>
        </span>
        <button @click.stop="removeFile(fileWithMeta)" class="remove-file-button">&times;</button>

        <div v-if="fileWithMeta.statusKey === 'uploading' || fileWithMeta.statusKey === 'success'" class="progress-bar-container">
          <div class="progress-bar" :style="{ width: fileWithMeta.upload.progress + '%' }"></div>
        </div>

        <div class="files-list__tooltip">
          <div class="files-list__tooltip-content">
            <template v-if="isImageFile(fileWithMeta.originalFile)"> <img
              :src="filePreviewUrls[fileWithMeta.upload.uuid]" :alt="`Перегляд файлу ${fileWithMeta.name}`"
              class="preview-thumbnail"
            />
            </template>
            <template v-else>
              <p><strong>Назва:</strong> {{ fileWithMeta.name }}</p>
              <p><strong>Розмір:</strong> {{ formatBytes(fileWithMeta.size) }}</p>
              <p><strong>Тип:</strong> {{ fileWithMeta.type || 'Не визначено' }}</p>
            </template>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { fileUtils } from '@/shared/ui/file-upload';

export default {
  mixins: [ fileUtils ],
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    filePreviewUrls: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    removeFile(fileWithMeta) {
      this.$emit('remove-file', fileWithMeta);
    },
    getStatusText(fileWithMeta) {
      const statusMap = {
        'queued': 'в черзі',
        'pending': 'очікується',
        'uploading': 'завантаження',
        'success': 'успішно',
        'error': 'помилка',
        'cancelled': 'скасовано',
      };
      return statusMap[fileWithMeta.statusKey] || statusMap[fileWithMeta.status] || fileWithMeta.status;
    },
    statusClass(fileWithMeta) {
      const statusKey = fileWithMeta.statusKey || 'pending';
      return {
        'text-success': statusKey === 'success',
        'text-danger': statusKey === 'error',
        'text-warning': statusKey === 'uploading',
        'text-info': statusKey === 'pending' || statusKey === 'queued',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.files-list {
  width: 100%;
  padding: 0 15px;
  text-align: left;

  h4 {
    margin-top: 0;
    color: #333;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  &__item {
    position: relative;
    padding: 8px 0;
    border-bottom: 1px dashed #F5F5F5;
    color: #09090B;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    &:last-child {
      border-bottom: none;
    }

    &:hover .files-list__tooltip {
      visibility: visible;
      opacity: 1;
    }
  }

  &__tooltip {
    position: absolute;
    visibility: hidden;
    opacity: 0;
    width: 200px;
    background-color: #FFFFFF;
    color: #09090B;
    text-align: center;
    border-radius: 6px;
    padding: 4px;
    bottom: 125%;
    left: 50%;
    margin-left: -75px;
    pointer-events: none;
    z-index: 1000;
    transition: opacity 0.3s, visibility 0.3s;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: #FFFFFF transparent transparent transparent;
    }
  }

  &__tooltip-content {
    text-align: left;
    font-size: 0.9em;

    p {
      margin: 0;
      line-height: 1.4;
    }
  }
}

.text-success {
  color: green;
  font-weight: bold;
}

.text-danger {
  color: red;
  font-weight: bold;
}

.text-warning {
  color: orange;
  font-weight: bold;
}

.text-info {
  color: #007bff;
  font-weight: bold;
}

.preview-thumbnail {
  max-width: 100%;
  height: auto;
  display: block;
  margin-bottom: 5px;
  border-radius: 4px;
}

.remove-file-button {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  color: #09090B;
  width: 24px;
  height: 24px;
  font-size: 14px;
  margin-left: 10px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.remove-file-button:hover {
  background-color: #F5F5F5;
  border-radius: 5px;
}

.progress-bar-container {
  width: 100%;
  height: 6px;
  background-color: #e0e0e0;
  border-radius: 3px;
  overflow: hidden;
  margin-top: 5px;
  margin-bottom: 5px;
}

.progress-bar {
  height: 100%;
  background-color: #FB923C;
  border-radius: 3px;
  transition: width 0.1s ease-in-out;
}
</style>
